import { render, staticRenderFns } from "./TicketDetailsUser.vue?vue&type=template&id=7de164de&"
import script from "./TicketDetailsUser.vue?vue&type=script&lang=js&"
export * from "./TicketDetailsUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports